<template>
  <v-list-group
    ref="refVListGroup"
    class="vertical-nav-menu-group text--primary"
  >
    <!-- Icône du groupe avec badge si des enfants ont des notifications -->
    <template #prependIcon>
      <v-badge
        v-if="totalBadge > 0"
        :content="totalBadgeDisplay"
        color="error"
        overlap
        bordered
        offset-x="2"
        offset-y="2"
      >
        <font-awesome-icon
          :class="{ 'alternate-icon-small': !icon }"
          :icon="['fas', icon]"
        />
      </v-badge>

      <font-awesome-icon
        v-else
        :class="{ 'alternate-icon-small': !icon }"
        :icon="['fas', icon]"
      />
    </template>

    <!-- Titre du groupe avec indicateur discret -->
    <template #activator>
      <v-list-item-title>
        {{ title }}
        <span v-if="totalBadge > 0" class="group-notif-dot ml-1" />
      </v-list-item-title>
    </template>

    <!-- Les NavMenuLink enfants sont injectés ici -->
    <slot></slot>
  </v-list-group>
</template>

<script>
export default {
  name: 'NavMenuGroup',

  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    // Liste des catégories de notification des enfants de ce groupe
    // ex: ['deposit_requests'] pour le groupe "Deposits"
    // Le groupe additionne automatiquement les counts de ses enfants
    notifCategories: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalBadge() {
      if (!this.notifCategories.length) return 0
      const counts = this.$store.state.notification_counts
      return this.notifCategories.reduce(
        (sum, cat) => sum + (counts[cat] || 0),
        0
      )
    },

    totalBadgeDisplay() {
      return this.totalBadge > 99 ? '99+' : String(this.totalBadge)
    },
  },
}
</script>

<style lang="scss">
.app-navigation-menu {
  .v-list-item {
    padding-left: 22px;
    margin-top: 0.375rem;
    height: 44px;
    min-height: 44px;

    .v-list-item__icon {
      margin-top: 0;
      margin-bottom: 0;
      align-self: center;
    }
  }

  @include theme(v-list-group__header) using ($material) {
    &.v-list-item--active {
      background-color: rgba(
        map-deep-get($material, 'text', 'primary'),
        map-deep-get($material, 'states', 'selected')
      );
    }
  }

  .vertical-nav-menu-group {
    & > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transform: rotate(-90deg);
    }

    &.v-list-group--active
      > .v-list-group__header
      > .v-list-group__header__append-icon
      .v-icon {
      transform: none;
    }
  }
}

// Petit point rouge discret sur le titre du groupe
.group-notif-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  background-color: #f44336;
  border-radius: 50%;
  vertical-align: middle;
  margin-bottom: 2px;
}
</style>
